module.exports = "<app-paytm-payment-details></app-paytm-payment-details>"